<template>
  <div class="d-flex nota-linea align-center" @click="dialog=true">
    <p
      class=" grey--text d-flex align-center text-truncate mb-0 px-2"
      v-if="nota === '' || nota === null">
      <v-icon class="mr-2 grey--text no-flex">edit_note</v-icon>
        No hay notas
    </p>
    <p  class=" bg-blue align-center d-flex align-center text-truncate mb-0 px-2" v-else >
      <v-icon class="mr-2 primary--text no-flex">edit_note</v-icon>
      {{ nota.slice(0, 20) }}
    </p>
    <v-btn
      icon
      text
      small
      class=" elevation-0 primary mr-0 my-0"
      >
      <v-icon v-if="nota === '' || nota === null">add</v-icon>
      <v-icon class="body-2" v-else>edit</v-icon>
    </v-btn>
    <v-dialog
        v-model="dialog"
        max-width="500"
        persistent
      >
        <div style="min-height: 300px;" class="scan-dialog">
            <v-toolbar flat class="d-flex justify-space-between ">
              <v-toolbar-title class="primary-color">
                <v-icon class="mr-2 primary-color">edit_note</v-icon>
                Añadir nota
              </v-toolbar-title>
              <v-btn 
                icon
                flat
                class="primary-color"
                @click="dialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <div class="px-4 pt-2 pb-5 nota-dialog">
              <v-btn top right icon class="primary" @click="deleteNota()" title="Eliminar">
                  <v-icon>delete</v-icon>
              </v-btn>
              <v-textarea 
                placeholder="Añade la nota aquí"
                class="pt-4"
                solo
                v-model="nota" no-resize base-color="#B0BEC5">
              </v-textarea> 
              <v-text-field
                label="Añadir coste extra unitario"
                type="number"
                v-model="coste"
                append-icon ="euro"
              ></v-text-field>         
            </div>
        </div>
        <v-btn v-if="dialog" large dark fab absolute bottom right class="orange guardar" @click='addNota()'>
          <!-- {{ $t('lang.comun.guardar') }}-->
          <v-icon>save</v-icon>
        </v-btn>
      </v-dialog>
  </div>
</template>

<script>
import { TicketApiService } from '@/api/TicketApiService'
const ticketApiService = new TicketApiService()

export default {
  name: 'nota',
  data() {
    return {
      dialog: false,
    }
  },
  props: {
    idProducto: {
      type: Number,
      required: false, 
      default: null 
    },
    codProducto: {
      type: String,
      required: false, 
      default: '' 
    },
    nota: {
      type: String,
      required: false, 
      default: '',
    },
    coste: {
      type: Number,
      required: false, 
      default: 0,
    },
    uidLineaTicket: {
      type: String,
      required: false, 
      default: '',
    },
  },
  watch: {
    dialog (value) {
      if (value) {
        this.openNota()
      }
    },
    uidLineaTicket (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.init()
      }
    },
    codProducto (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.init()
      }
    },
    idProducto (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.init()
      }
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    openNota() {
			this.dialog = true
      this.init()
		},
    init() {
      this.nota = ''
      if (this.uidLineaTicket && this.uidLineaTicket !== '') {
        ticketApiService.getLineaTicket(this.uidLineaTicket)
          .then((data) => {
            this.nota = data.mslt_nota
            this.coste = data.mslt_coste_extra
          })
          .catch(error => {
            console.log(error)
            this.$root.$emit('mostrarAlerta', 'Error', 'error')
          })
      } else {
        let data = {
          id: this.idProducto,
          codigo: this.codProducto
        }
        let linea = this.$store.getters.getArticuloCart(data)
        if (linea.nota) {
          this.nota = linea.nota
          this.coste = linea.coste
        }
      }
    },
		addNota() {
			if (this.nota && this.nota.trim() !== '') {
        if (this.uidLineaTicket && this.uidLineaTicket !== '') {
          let lineaTicket = {
            mslt_uid : this.uidLineaTicket,
            mslt_nota:  this.nota,
            mslt_coste_extra:  this.coste
          }
          ticketApiService.updateLineaTicket(lineaTicket)
          .then(() => {
            this.init()
            this.$emit('actualizar', this.coste)
            this.$root.$emit('mostrarAlerta', 'Nota guardada correctamente', 'info')
            this.dialog = false
          })
          .catch(error => {
            console.log(error)
            this.$root.$emit('mostrarAlerta', 'Error al guardar la nota', 'error')
          })

        } else {
          let data = {
            id: this.idProducto,
            codigo: this.codProducto,
            nota: this.nota.trim(),
            coste: this.coste
          }
          this.$emit('actualizar', this.coste)
          this.$store.commit('addNotaLinea', data)
          this.init()
          this.dialog = false
        }	
			} else {
				this.$root.$emit('mostrarAlerta', 'Debe rellenar la nota', 'error')
			}
		},
    deleteNota() {
      if (this.uidLineaTicket && this.uidLineaTicket !== '') {
        this.nota=''
        let lineaTicket = {
          mslt_uid : this.uidLineaTicket,
          mslt_nota:  '',
          mslt_coste_extra: 0
        }
        ticketApiService.updateLineaTicket(lineaTicket)
        .then(() => {
          this.$emit('actualizar', 0)
          this.$root.$emit('mostrarAlerta', 'Nota borrada correctamente', 'info')
          this.dialog = false
        })
        .catch(error => {
          console.log(error)
          this.$root.$emit('mostrarAlerta', 'Error al borrar la nota', 'error')
        })

      } else {
        this.nota=''
        let data = {
          id: this.idProducto,
          codigo: this.codProducto,
          nota: '',
          coste: 0
        }
        this.$emit('actualizar', 0)
        this.$store.commit('addNotaLinea', data);
        this.dialog = false
      }
    }
  },
}
</script>
